import React, {useEffect, useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {ModeleReseauClient} from '../../../components/Models'
import {
  deleteReseauClient,
  getReseauClients,
  unaffectReseauClient,
} from '../../../components/requests'
import {LoadingData} from '../../../components/LoadingData'
import Swal from 'sweetalert2'
import {useFormik} from 'formik'
import {Pagination} from '../../../components/Pagination'
import {useAuth} from '../../modules/auth'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {ReseauClientAffectModal} from './ReseauClientAffectModal'
import {toast, ToastContainer} from 'react-toastify'
import {Tooltip} from 'react-tooltip'

interface ReseauProps {
  clientId?: string | number | undefined
  displayClientInfo?: boolean
  isFromModalClient?: boolean
}

const ReseauClientListPage = ({
  displayClientInfo = false,
  clientId = '',
  isFromModalClient,
}: ReseauProps) => {
  const [data, setData] = useState<Array<ModeleReseauClient>>([])
  const [loading, setLoading] = useState(true)

  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [searchPage, setSearchPage] = useState<string>('')
  const [isSearch, setIsSearch] = useState(false)
  const {currentUser} = useAuth()

  useEffect(() => {
    getReseauClientData()
  }, [currentPage, searchPage])

  const getReseauClientData = () => {
    setLoading(true)
    // Requête qui liste les reseaux par rapport au reseau du client
    // si clientId n'est pas un nombre, retourne toute la liste des reseaux
    getReseauClients(!isSearch ? currentPage : 1, searchPage, clientId)
      .then((reseauClientRequest) => {
        setNombreDePages(reseauClientRequest?.pages)
        setTotalPages(reseauClientRequest?.total)
        setCurrentPage(reseauClientRequest?.page)
        if (reseauClientRequest?.data !== undefined) {
          setData(reseauClientRequest?.data)
          setLoading(false)
          setIsSearch(false)
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  const delReseauClient = (reseauClientId) => {
    Swal.fire({
      title: 'Attention',
      text: 'Merci de confirmer la suppression',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        setLoading(true)
        deleteReseauClient(reseauClientId)
          .then((response) => {
            if (response?.status === 200) {
              setLoading(false)
              getReseauClientData()
            }
          })
          .catch((error) => {
            if (error.response?.status === 423) {
              setLoading(false)
              Swal.fire({
                title: 'Erreur',
                text: 'Ce centre ne peut pas être supprimé.',
                icon: 'error',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#F64E60',
              })
            }
          })
      }
    })
  }

  // Popup de verification si l'utilisateur connecté souhaite vraiment désaffecter le reseau
  // Dans la page detail client section reseau
  const unaffectReseau = (clientId, reseauClientId) => {
    if (displayClientInfo && clientId !== '') {
      Swal.fire({
        title: 'Attention',
        text: 'Merci de confirmer la désaffectation du réseau',
        icon: 'warning',
        confirmButtonText: 'Confirmer',
        cancelButtonText: 'Annuler',
        showCancelButton: true,
        confirmButtonColor: '#1BC5BD',
        cancelButtonColor: '#F64E60',
      }).then((result) => {
        if (result.isConfirmed) {
          const toastId = toast.loading('Désaffectation en cours', {position: 'bottom-right'})
          unaffectReseauClient(clientId, reseauClientId)
            .then((res) => {
              if (res.data === 'Success' && res.status === 200) {
                const filteredData = data.filter((reseau) => reseau.id !== reseauClientId)
                setData(filteredData)
                toast.update(toastId, {
                  render: 'Réseau client désaffecté avec succès',
                  type: 'success',
                  isLoading: false,
                  autoClose: 3000,
                })
              } else if (res.data === 'Error' && res.status === 404) {
                toast.update(toastId, {
                  render: 'Réseau client non trouvé',
                  type: 'warning',
                  isLoading: false,
                  autoClose: 3000,
                })
              }
            })
            .catch((error) => {
              console.log('erreur')
              toast.update(toastId, {
                render: 'Erreur durant la désaffectation du réseau client',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
              })
            })
        }
      })
    }
  }

  const formik = useFormik({
    initialValues: {search: ''},
    onSubmit: (values, {setSubmitting}) => {
      setIsSearch(true)
      setSearchPage(values.search)
    },
  })

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-xxl-12'>
          <div
            className={`card card-xxl-stretch mb-5 mb-xl-8`}
            style={{background: isFromModalClient ? '#80808014' : ''}}
          >
            {/* begin::Header */}
            {!isFromModalClient && (
              <div className='card-header border-0 pt-5 justify-content-end'>
                {displayClientInfo && clientId !== '' ? (
                  <ReseauClientAffectModal clientId={clientId} data={data} setData={setData} />
                ) : (
                  shouldDisplayFonctionnalite(currentUser, 'AJOUTER RESEAU CLIENT') && (
                    <div className='card-toolbar'>
                      <Link to={`/reseau-client/ajouter`} className='btn btn-sm btn-light-primary'>
                        <KTIcon iconName='plus' className='fs-3' />
                        Créer un réseau client
                      </Link>
                    </div>
                  )
                )}
              </div>
            )}
            {/* end::Header */}

            {/* debut champs recherche */}
            {!isFromModalClient && (
              <form className='card-header border-0 pt-5 pb-5' onSubmit={formik.handleSubmit}>
                <div></div>
                <div className='form-group d-flex col-lg-4'>
                  <div className='input-group'>
                    <input
                      type='text'
                      className='form-control h-100'
                      {...formik.getFieldProps('search')}
                      name='search'
                      placeholder='Rechercher un réseau client'
                    />
                    <button
                      type='submit'
                      className='btn btn-light border-0 input-group-append h-100'
                      onClick={() => setIsSearch(true)}
                    >
                      <i className='fas fa-search text-secondary fs-1'></i>
                    </button>
                  </div>
                </div>
              </form>
            )}
            {/* fin champs recherche */}

            {loading ? (
              <LoadingData />
            ) : (
              <>
                {shouldDisplayFonctionnalite(currentUser, 'VOIR RESEAU CLIENT') && (
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th>Code</th>
                            <th className='min-w-140px'>Nom</th>
                            {!isFromModalClient && (
                              <th className='min-w-100px text-end'>Actions</th>
                            )}
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {data.length ? (
                            data.map((reseauClient) => {
                              return (
                                <tr key={reseauClient.id}>
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      <div className='d-flex justify-content-start flex-column'>
                                        {reseauClient.code}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                      {reseauClient.nom}
                                    </p>
                                  </td>
                                  {!isFromModalClient && (
                                    <td>
                                      <div className='d-flex justify-content-end flex-shrink-0'>
                                        {/* Si display reseau est true et clientId est un nombre */}
                                        {displayClientInfo && clientId !== '' ? (
                                          <p
                                            onClick={() =>
                                              unaffectReseau(clientId, reseauClient.id)
                                            }
                                            className='btn  btn-icon btn-light-danger btn-sm me-1'
                                            data-tooltip-place='left'
                                            data-tooltip-id='unaffect-reseau'
                                            data-tooltip-content='Désaffecter le réseau'
                                          >
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              width='20'
                                              height='20'
                                              viewBox='0 0 16 16'
                                            >
                                              <path
                                                fill='currentColor'
                                                d='M15.354.646a.5.5 0 0 0-.707 0l-2.07 2.07c-1.37-.999-3.37-.843-4.64.428l-.13.131a1.25 1.25 0 0 0 0 1.768l3.181 3.182c.243.244.563.366.884.366s.641-.122.884-.366l.22-.22a3.47 3.47 0 0 0 1.025-2.529a3.46 3.46 0 0 0-.71-2.059l2.063-2.063a.5.5 0 0 0 0-.708m-3.086 6.651l-.22.22a.25.25 0 0 1-.354 0L8.512 4.335a.25.25 0 0 1 0-.354l.131-.131a2.7 2.7 0 0 1 1.897-.79c.61 0 1.211.214 1.671.648c.498.468.777 1.101.788 1.783a2.48 2.48 0 0 1-.73 1.806M8.146 9.146l-.88.88l-1.293-1.293l.88-.88a.5.5 0 0 0-.707-.707l-.88.88l-.253-.253a1.253 1.253 0 0 0-1.768.001l-.22.22A3.47 3.47 0 0 0 2 10.523c.012.756.26 1.47.71 2.059L.647 14.645a.5.5 0 0 0 .708.707l2.07-2.07a3.45 3.45 0 0 0 2.036.652c.938 0 1.888-.363 2.604-1.08l.131-.131a1.25 1.25 0 0 0 0-1.768l-.222-.222l.88-.88a.5.5 0 0 0-.707-.707m-.657 2.872l-.132.131c-.994.995-2.596 1.059-3.568.142a2.48 2.48 0 0 1-.788-1.783c-.01-.682.25-1.324.732-1.806l.22-.22a.25.25 0 0 1 .177-.073c.065 0 .128.024.177.073l3.18 3.18a.25.25 0 0 1 0 .354z'
                                              />
                                            </svg>
                                          </p>
                                        ) : (
                                          <>
                                            {shouldDisplayFonctionnalite(
                                              currentUser,
                                              'MODIFIER RESEAU CLIENT'
                                            ) && (
                                              <Link
                                                to={`/reseau-client/${reseauClient.id}/modifier`}
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                              >
                                                <i className='bi bi-pencil-square fs-2'></i>
                                              </Link>
                                            )}
                                            {shouldDisplayFonctionnalite(
                                              currentUser,
                                              'SUPPRIMER RESEAU CLIENT'
                                            ) && (
                                              <p
                                                onClick={() => delReseauClient(reseauClient.id)}
                                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 my-0'
                                              >
                                                <i className='bi bi-trash fs-2'></i>
                                              </p>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={4} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    <Pagination
                      totalPages={totalPages}
                      nombreDePages={nombreDePages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      locationState={0}
                    />
                    {/* end::pagination*/}

                    <ToastContainer />
                    <Tooltip id='unaffect-reseau' />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
    </>
  )
}

export {ReseauClientListPage}
